<div class="flex items-baseline headline-x-small mb-2">
  <i class="fa-kit fa-contract-new"></i>
  <div class="flex flex-wrap pl-2">
    <span [innerText]="'Dashboard.ContractRequests' | translate"></span>
  </div>
</div>

<div class="grid grid-cols-1 xl:grid-cols-2 2xl:grid-cols-3 gap-5 mt-2" [dynamicContractsGrid]="contractRequests">
  @for (contractRequest of contractRequests; track contractRequest.id) {
    <div
      class="card flex flex-col"
      [ngClass]="{
        grayscale: contractRequest.status == 'declined',
      }"
    >
      <div class="card-body inline-flex w-full">
        <div class="text-success-dark mr-3">
          <i class="text-4xl fa-kit fa-parking mt-1"></i>
        </div>
        <div class="flex items-center w-full">
          <div class="w-100">
            @if (contractRequest.garage) {
              <div class="body-large">{{ contractRequest.garage.name }}</div>
              @if (hasCompleteGarageAddress(contractRequest)) {
                <div class="body-medium text-neutral-50">
                  {{ formatAddress(contractRequest.garage.street, contractRequest.garage.number, contractRequest.garage.zip_code, contractRequest.garage.city) }}
                </div>
              }
            } @else {
              <div class="body-large">{{ contractRequest.name }}</div>
            }
          </div>
          <div class="ml-auto flex items-start h-full">
            <div class="flex items-center border-2 rounded p-2">
              <i class="text-large fa-light mr-2" [ngClass]="{
                                'fa-clock': contractRequest.status === 'pending',
                                'fa-ban': contractRequest.status === 'declined',
                                }"></i>
              <p class="body-medium" [innerText]="'Dashboard.Contracts.ContractRequestStatus.' + contractRequest.status | translate"></p>
            </div>
          
          </div>
        </div>
      </div>
      <div class="card-body inline-flex items-center w-full gap-2">
        <div class="flex flex-col flex-shrink min-w-0">
          <div class="body-medium text-neutral-50" [innerText]="'Dashboard.Contracts.Contract' | translate"></div>
          <div class="body-medium text-neutral-10">{{ contractRequest.name }}</div>
        </div>
        <div class="inline-flex flex-shrink-0 ml-auto">
          <div class="body-large">
            <i class="fa-kit fa-parking-space mr-1.5"></i>
            <span [innerText]="contractRequest.group_limit"></span>
          </div>
        </div>
      </div>
      <div class="card-body w-full flex-grow">
        @if (contractRequest.license_plates.length > 0) {
          <div class="body-medium text-neutral-50" [innerText]="'Dashboard.Contracts.AllowedVehicles' | translate"></div>
          <div class="flex flex-wrap justify-between items-center gap-2 mt-2">
            @for (licensePlate of contractRequest.license_plates; track $index) {
              <arivo-license-plate [country]="licensePlate.license_plate_country" [licensePlate]="licensePlate.license_plate" />
            }
          </div>

        } @else {
          <div class="body-medium mt-1 flex flex-col">
            <div class="flex items-center justify-center mb-2">
              <i class="fa-light fa-triangle-exclamation mr-2 text-2xl text-error"></i>
              <div class="text-lg text-error" [innerText]="'Dashboard.Contracts.NoVehiclesAllowed' | translate"></div>
            </div>
          </div>
        }
      </div>
      <div class="card-body items-center grid grid-cols-5 gap-x-4 gap-y-1">
        <div class="body-medium text-neutral-50 col-span-2" [innerText]="'Dashboard.Contracts.MonthlyPrice' | translate"></div>
        <div class="body-medium text-neutral-10 text-right col-span-3">
          {{ contractRequest.price.amount | localizedCurrency: contractRequest.price.currency }}
        </div>

        <div class="body-medium text-neutral-50 col-span-2" [innerText]="'Dashboard.Contracts.ContractDurationFrom' | translate"></div>
        <div class="body-medium text-neutral-10 text-right col-span-3">
          {{ contractRequest.start | localizedDate }}
        </div>
        
      </div>
      @if (contractRequest.price_adjustment || showVpi) {
        <div class="card-body items-center grid grid-cols-5 gap-x-4 gap-y-1">
          @if (contractRequest.price_adjustment) {
            <div
              class="body-medium text-neutral-50 col-span-2"
              [innerText]="'Dashboard.Contracts.PriceIncreaseLabel' | translate"
            ></div>
            <div class="body-medium text-neutral-10 text-right col-span-3">
              {{ getPriceIncreaseString(contractRequest) }}
            </div>
          }
          @if (showVpi) {
            <div class="body-medium text-neutral-50 col-span-2" [innerHTML]="'Dashboard.Contracts.VpiLabel' | translate"></div>
            <div
              class="body-medium text-neutral-10 text-right col-span-3"
              [innerHTML]="'Dashboard.Contracts.VpiContext' | translate: { url: providerLinks.terms_and_conditions.url }"
            ></div>
          }
        </div>
      }
    </div>
  }
</div>
